import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_get_owner_logo_attachmentService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: { orderId: number }): Promise<{ result?: { Id?: number, FileName?: string, FileExtension?: string, Description?: string, CreatedSysDateTime?: string, ModifiedSysDateTime?: string, FileSize?: number, FileContent?: string } }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      orderId: number    }) {
        if(isNil($inParams.orderId)) {
          return true; 
        }
      return false;
    }
}
